import { CoreTabGroupSwitch, CoreTabRoute, useAuth } from '@amzn/dots-core-ui';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { CorePage, CorePageTitle } from '$/components';
import { HostDetailUri, HostsUri, RootUri } from '$/features/routes';
import _ from 'lodash';
import { HostData } from '@amzn/dots-host-agent-management-service-client';
import { getHamsClient, getHost } from '$/api/client/client';
import { HostAgentSetting, HostSettingsForm } from './components';

// TODO: transition off dummy data to api.
const DUMMY_DATA: HostAgentSetting[] = [
  {
    settingName: 'Download Cache Days',
    sectionName: 'AGENT Settings',
    settingValue: 21,
  },
  {
    settingName: 'Min % Charge',
    sectionName: 'AGENT Settings',
    settingValue: undefined,
  },
  {
    settingName: 'KATS URL',
    sectionName: 'KATS Settings',
    settingValue: undefined,
  },
  {
    settingName: 'Kats Secret Management URL',
    sectionName: 'KATS Settings',
    settingValue: undefined,
  },
  {
    settingName: 'KBITS URL',
    sectionName: 'KBITS Settings',
    settingValue: undefined,
  },
];

export function HostSettingsPage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  // const { openToast } = useToaster();

  const [host, setHost] = useState<HostData | undefined>(undefined);
  const auth = useAuth();

  useEffect(() => {
    async function fetchHost() {
      const hamsClient = await getHamsClient(auth);

      const response = await getHost({ accountName: id }, hamsClient);
      setHost(response?.host);
    }

    fetchHost();
  }, [auth, id]);

  const onSubmit = useCallback(() => {
    // TODO: link with new hams
    console.log('hello');
  }, []);

  const settingTabs = _.groupBy(DUMMY_DATA, 'sectionName') as {
    string: HostAgentSetting[];
  };
  return (
    <CorePage
      title="Settings"
      breadcrumbs={[
        { title: 'Scheduling', href: RootUri },
        { title: 'Host Agents', href: HostsUri },
        { title: host?.accountName ?? '', href: HostDetailUri(id) },
      ]}
      header={
        <CorePageTitle title={host ? `${host?.accountName} Settings` : ''} />
      }
    >
      <CoreTabGroupSwitch>
        {Object.entries(settingTabs).map(([sectionName, settings]) => {
          return (
            <CoreTabRoute
              key={sectionName}
              label={sectionName}
              path={sectionName}
            >
              <HostSettingsForm
                onCancel={() => history.push(HostDetailUri(id))}
                onSubmit={onSubmit}
                host={host}
                settings={settings}
              />
            </CoreTabRoute>
          );
        })}
      </CoreTabGroupSwitch>
    </CorePage>
  );
}
